import axios from 'axios';
import {AuthAction, AuthMutation} from "./types";
import router from "@/router";

export default {
    [AuthAction.LOGIN]({commit}, user) {
        return new Promise((resolve, reject) => {
            commit(AuthMutation.AUTH_REQUEST);

            axios.post('/security/login', user)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    const token = data.token;
                    const user = data;

                    localStorage.setItem('token', token);
                    axios.defaults.headers.common['X-AUTH-TOKEN'] = token;

                    commit(AuthMutation.AUTH_SUCCESS, {token, user});

                    resolve(data);
                })
                .catch(err => {
                    commit(AuthMutation.AUTH_ERROR, err.response.data || err);
                    localStorage.removeItem('token');
                    reject(err);
                });
        });
    },
    [AuthAction.LOGOUT]({commit}) {
        return new Promise((resolve) => {
            commit(AuthMutation.AUTH_LOGOUT);
            localStorage.removeItem('token');
            delete axios.defaults.headers.common['X-AUTH-TOKEN'];

            resolve();
        });
    },
    [AuthAction.LOAD_USER]({commit}) {
        return new Promise((resolve, reject) => {
            commit(AuthMutation.AUTH_REQUEST);

            axios.get('/security/user')
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    const user = data;
                    commit(AuthMutation.AUTH_SUCCESS, {token: user.token, user});
                    resolve(user);
                })
                .catch(err => {
                    commit(AuthMutation.AUTH_ERROR, err.response.data || err);
                    localStorage.removeItem('token');
                    router.push('/login');
                    reject(err);
                });
        });
    },
    [AuthAction.UPDATE_USER]({commit}, user) {
        return new Promise((resolve, reject) => {
            commit(AuthMutation.AUTH_REQUEST);

            axios.post(`/security/user/${user.id}`, user)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(AuthMutation.UPDATE_SUCCESS, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(AuthMutation.UPDATE_ERROR, err.response ? err.response.data : err);
                    reject(err);
                })
        });
    },
    [AuthAction.UPDATE_USER_WITH_LOGO]({commit}, user) {
        return new Promise((resolve, reject) => {
            commit(AuthMutation.AUTH_REQUEST);

            let formData = new FormData();

            const assetFields = [
                '_image',
                '_terms',
                '_info',
                '_securedPayment',
                '_csrCertificate',
            ];

            for (let i = 0, l = assetFields.length; i < l; i++) {
                const field = assetFields[i];
                if(Object.prototype.hasOwnProperty.call(user, field) && user[field]) {
                    formData.append(field, user[field]);
                }
            }

            for(let i in user) {
                if(
                    false === Object.prototype.hasOwnProperty.call(user, i) ||
                    assetFields.indexOf(i) > -1
                ) {
                    continue;
                }
                formData.append(i, user[i]);
            }

            axios.post(
                `/security/user/${user.id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                )
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(AuthMutation.UPDATE_SUCCESS, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(AuthMutation.UPDATE_ERROR, err.response ? err.response.data : err);
                    reject(err);
                })
        });
    },
}
